"use client"

import type { Tokens } from "@mux/playback-core"
import { UserId } from "@wise/identities"
import mixpanel from "mixpanel-browser"
import type { StaticImageData } from "next/image"
import Video from "next-video"
import type { Asset } from "next-video/dist/assets.js"
import { useEffect } from "react"

interface Props {
    src: Asset
    tokens?: Tokens | undefined
    metadata: {
        title: string
        slug: string
        free: boolean
        userId?: string
    }
    poster?: StaticImageData | undefined
}

export function VideoWrapper({ src, tokens, metadata, poster }: Props) {
    const userId = metadata.userId ? UserId.fromUrl(metadata.userId) : null

    const onPlay = () => {
        mixpanel.track("Academy: Video play", {
            title: metadata.title,
            slug: metadata.slug,
            free: metadata.free,
            authenticated: tokens !== undefined,
            ...(userId && { distinct_id: userId.id }),
        })
    }

    return (
        <Video
            src={src}
            onPlay={onPlay}
            playbackToken={tokens?.playback}
            tokens={tokens}
            metadata={{
                video_id: metadata.slug,
                video_title: metadata.title,
                ...(metadata.userId && { viewer_user_id: metadata.userId }),
            }}
            poster={poster}
        />
    )
}
